module.exports = __webpack_public_path__ + "static/media/Bluelagoo.179af69b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/css/Bluelagoo.jpg
// module id = 18
// module chunks = 0